/*
ヘルプコンテンツ（WEB・アプリ共通）
*/
import React from "react"
import { Link } from "gatsby"
import AnchorLink from 'react-anchor-link-smooth-scroll'

import icon_Arrow from "../images/Arrow.png"
import appstore from "../images/appstore.svg"
import googlePlay from "../images/google-play-badge.png"
import APPstoreQR from "../images/APPstoreQR.png"
import playsStoreQR from "../images/playStoreQr.png"
import help_02_01_1 from "../images/help/help_02_01_1.png"
import help_02_01_2 from "../images/help/help_02_01_2.png"
import help_02_02_1 from "../images/help/help_02_02_1.png"
import help_02_02_2 from "../images/help/help_02_02_2.png"
import help_02_03 from "../images/help/help_02_03.png"
import help_02_04_1 from "../images/help/help_02_04_1.png"
import help_02_04_2 from "../images/help/help_02_04_2.png"
import help_02_06 from "../images/help/help_02_06.png"
import help_02_07 from "../images/help/help_02_07.png"
import help_02_08_1 from "../images/help/help_02_08_1.png"
import help_02_08_2 from "../images/help/help_02_08_2.png"
import help_04_01 from "../images/help/help_04_01.png"
import help_05_02_1 from "../images/help/help_05_02_1.png"
import help_05_02_2 from "../images/help/help_05_02_2.png"
import help_05_03_1 from "../images/help/help_05_03_1.png"
import help_05_03_2 from "../images/help/help_05_03_2.png"
import help_06_02_1 from "../images/help/help_06_02-1.png"
import help_06_02_2 from "../images/help/help_06_02-2.png"
import help_06_02_3 from "../images/help/help_06_02-3.png"
import help_06_02_4 from "../images/help/help_06_02-4.png"
import help_06_03_1 from "../images/help/help_06_03-1.png"
import help_06_03_2 from "../images/help/help_06_03-2.png"
import help_06_03_3 from "../images/help/help_06_03-3.png"
import help_06_03_4 from "../images/help/help_06_03-4.png"
import help_06_03_5 from "../images/help/help_06_03-5.png"
import help_06_03_6 from "../images/help/help_06_03-6.png"
import help_06_03_7 from "../images/help/help_06_03-7.png"
import help_06_04_1 from "../images/help/help_06_04-1.png"
import help_06_04_2 from "../images/help/help_06_04-2.png"
import help_06_04_3 from "../images/help/help_06_04-3.png"
import help_06_04_4 from "../images/help/help_06_04-4.png"
import help_06_04_5 from "../images/help/help_06_04-5.png"
import help_06_04_6 from "../images/help/help_06_04-6.png"
import help_06_05_1 from "../images/help/help_06_05_1.png"
import help_06_05_2 from "../images/help/help_06_05_2.png"
import help_06_05_3 from "../images/help/help_06_05_3.png"
import help_06_05_4 from "../images/help/help_06_05_4.png"
import help_06_05_5 from "../images/help/help_06_05_5.png"


const HelpContents = ({ location, title, children }) => {
  return (
    <div className="HelpContents">

      <aside id="sidebar" className="help_sidebar">
        <div id="nav" className="nav">
          <h3>Help navigation</h3> 
          <div className="list_inner">
            <ul className="taLT">
              <li><AnchorLink href="#content_00" offset="70">
                よくあるご質問</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_01" offset="70">
                NuRseCallについて</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_02" offset="70">
                アカウント</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_03" offset="70">
                性格診断</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_04" offset="70">
                ストレス診断</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_06" offset="70">
                シフト共有カレンダー</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_05" offset="70">
                マイページ</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_07" offset="70">
                設定</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
              <li><AnchorLink href="#content_10" offset="70">
                その他</AnchorLink><img src={ icon_Arrow } className="icon_Arrow" />
              </li>
            </ul>
          </div>
        </div>
      </aside>

      <main id="main">
        <div className="help_container">
          
          <h4 id="content_00">よくあるご質問</h4>
          
          {/* <input type="checkbox" id="help_00_01" className="cssacc" />
          <label for="help_00_01">
            <img src={ icon_Arrow } className="icon_Arrow" />Android用のアプリはありますか？</label>
          <div className="accshow">
            現在は、iOS向けのアプリのみご利用可能です。<br />
            Android向けアプリは現在開発中でございます。リリースまで、もうしばらくお待ちください。<br />
          </div> */}
          
          <input type="checkbox" id="help_00_02" className="cssacc"/>
          <label for="help_00_02">
            <img src={ icon_Arrow } className="icon_Arrow" />質問を押し間違えましたが、性格診断のやり直しはできますか？</label>
          <div className="accshow">
            現在のバージョンでは性格診断をやり直すことはできません。<br />
            大変お手数ですが、別のメールアドレスで新規登録をしていただき、再度性格診断を行ってください。<br />
          </div>
          
          <input type="checkbox" id="help_00_03" className="cssacc" />
          <label for="help_00_03">
            <img src={ icon_Arrow } className="icon_Arrow" />ストレス診断結果はすぐ見れないのですか？</label>
          <div className="accshow">
            月4回のストレスチェックを行うことで、ストレスレベルを算定しております。<br />
            4回全てのストレスチェックが終わると、その月のストレスレベルやチャートなどが表示されるようになります。<br />
            ※初回登録時のみ、４回のストレスチェックを全て行い、すぐにストレス診断ができます。<br />
          </div>
          
          <input type="checkbox" id="help_00_04" className="cssacc" />
          <label for="help_00_04">
            <img src={ icon_Arrow } className="icon_Arrow" />ストレス診断結果はSNSでシェアできないのですか？</label>
          <div className="accshow">
            現在のバージョンでは、ストレスレベルの表示等のシェアはできません。<br />
            スクリーンショット等で共有して頂くことは可能です。<br />
          </div>


          <h4 id="content_01">NuRseCallについて</h4>
          
          <input type="checkbox" id="help_01_01" className="cssacc" />
          <label for="help_01_01">
            <img src={ icon_Arrow } className="icon_Arrow" />NuRseCallとは</label>
          <div className="accshow">
            NurseCall（ナースコール）アプリはストレスフルな現場で頑張る看護師の皆さんが、心と体を健全に保ち、みずみずしい生活を送れるようサポートすることを目標に創られました。<br />
            「毎日使える、ナースに便利なアプリ」にするためにシフト共有カレンダー機能を追加しました！<br />
            <br />
            【こんな方におすすめ】<br />
            ・夜勤などもあり生活リズムをキープするのが難しい<br />
            ・ドクター、上司・先輩、患者さん、患者さんのご家族などとの人間関係に悩んでいる<br />
            ・仕事量が多すぎて常に時間に追われている<br />
            ・患者さんの命を預かる仕事でプレッシャーがかかっている<br />
            ・最新の医療情報や看護スキルの習得で休みの日もゆっくりできない<br />
            ...などストレスをためがちなすべてのナースにおすすめのアプリです。<br />
            <br />
            ◆ NuRseCallアプリでは、性格タイプ診断（ナースエゴグラム）を行い、診断された性格タイプに合ったストレスチェックと解消方法を提案します。<br /><br />
            ◆ 月に4回、数件の質問項目に3択で答えるだけで、毎月のストレス度を表示します。手軽にセルフマネジメントができることが特徴です。<br /><br />
            ◆ シフト勤務の看護師向けに、シフト共有カレンダー機能を搭載。シフトも、プライベートの予定もこのカレンダーひとつで管理できます。<br /><br />
            ◆ NuRseCallアプリ同士なら、職場はもちろん、同期の仲間や友人、家族とシフトを共有することができます。<br />
            <br />
            ナースコールのロゴはRを反転(Reverse)させることで、自分自身へのナースコールという意味をもたせています。<br />
          </div>
          
          <input type="checkbox" id="help_01_02" className="cssacc" />
          <label for="help_01_02">
            <img src={ icon_Arrow } className="icon_Arrow" />主な機能</label>
          <div className="accshow">
            ■性格タイプ診断（ナースエゴグラム）<br />
            最初に50問の3択質問に答えて、あなたの性格タイプを確認してください。<br />
            29タイプからあなたの性格にもっとも近いタイプを判定します。<br />
            タイプ診断結果はSNSでシェアできます。<br />
            <br />
            ■定期ストレスチェック<br />
            月4回の定期チェックであなたのストレスレベルを把握（月1回更新）<br />
            <br />
            ■診断結果確認<br />
            全体的なストレスレベル、ストレス反応、ストレス要因がシンプルなグラフで前月比較表示されます。<br />
            <br />
            ■シフト共有カレンダー<br />
            シフトも、プライベートの予定もこのカレンダーひとつで管理できます。<br />
            １つの画面でシフト一覧やその日の予定を見ることができます。<br />
            シフトをスタンプ感覚で連続で入力でき、短時間でシフトの入力ができます。<br />
            イレギュラーなシフトに対応するために、1日に最大3件までシフトを入力できます。<br />
            NuRseCallアプリ同士なら、職場はもちろん、同期の仲間や友人、家族とシフトを共有することができます。<br />
            共有するグループは作成・招待・参加ができ、管理者機能で安全に運用できます。<br />
            <br />
            ■互換性<br />
            iOS 13.0以降。iPhone、iPad、およびiPod touchに対応。<br />
          </div>
          
          <input type="checkbox" id="help_01_03" className="cssacc" />
          <label for="help_01_03">
            <img src={ icon_Arrow } className="icon_Arrow" />ご利用料金</label>
          <div className="accshow">
            NurseCall（ナースコール）アプリは無料でご利用いただけます。<br />
            <small>※本アプリのダウンロードには別途パケット通信料がかかります。なお、パケット通信料は、ダウンロードする作品の容量とお客様のご契約いただいている料金プラン等により異なります。</small>
          </div>
          
          <input type="checkbox" id="help_01_04" className="cssacc" />
          <label for="help_01_04">
            <img src={ icon_Arrow } className="icon_Arrow" />アプリダウンロード</label>
          <div className="accshow">
            下記よりダウンロードしていただけます。
            <div className="APP_Link">
              <a href="https://apps.apple.com/jp/app/nursecall/id1539839928" target="_blank">
                <img src={ appstore } className="appstore-150" alt="APP Store からダウンロード" />
              </a>
              <img src={ APPstoreQR } />
            </div>
            <div className="APP_Link">
              <a target="_blank" href='https://play.google.com/store/apps/details?id=com.nurse_support.nursecall&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                <img alt='Google Play で手に入れよう' className="appstore-150" src={ googlePlay }/>
              </a>
              <img src={ playsStoreQR } />
            </div>
          </div>
          
          
          <h4 id="content_02">アカウント</h4>
          
          <input type="checkbox" id="help_02_01" className="cssacc" />
          <label for="help_02_01">
            <img src={ icon_Arrow } className="icon_Arrow" />新規登録
          </label>
          <div className="accshow">
            <div className="flex">
              <div>
                <img src={ help_02_01_1 } className="shadow" alt="ログイン・新規登録画面" />
                <img src={ help_02_01_2 } className="shadow" alt="新規登録画面" />
              </div>
              <p>
                アプリを立ち上げると、ログイン・新規登録の画面が表示されます。<br />
                　<br />
                ◇各プロバイダで新規登録する場合<br />（Google・Twitter・Facebook・AppleID）<br />
                <p>
                  ログインに利用するプロバイダをタップしてください。<br />
                  プロバイダのアクセス許可をすると、新規登録が完了します。
                </p>
                　<br />
                ◇メールアドレスで登録する場合<br />
                <p>
                  画面一番下の『メールアドレスで新規登録』をタップし、新規登録画面でメールアドレスとパスワードを入力して登録してください。<br />
                  ※パスワードは8文字以上の英数字で設定してください。<br />
                  その際、メールアドレスの確認メールが送信されますので受信したメールを確認して、メールを認証させてください。<br />
                  メールアドレス認証後にアプリが利用可能となります。<br />
                  ※確認メールが届かない場合は、迷惑メールに振り分けられていないかを確認してください。受信制限をしている場合は「@nurse-support.com」を許可してください。それでも届かない場合は登録したメールアドレスが誤っている場合がありますので、再度新規登録をしてください。<br />
                  ※メールアドレスを忘れた場合は、システム上アカウントを特定することができませんので、新規で登録し直しになります。メールアドレスは忘れないようにしてください。
                </p>
              </p>
              
            </div>
          </div>
          
          <input type="checkbox" id="help_02_02" className="cssacc" />
          <label for="help_02_02">
            <img src={ icon_Arrow } className="icon_Arrow" />ログイン
          </label>
          <div className="accshow">
            <div className="flex">
              <div>
                <img src={ help_02_02_1 } className="shadow" alt="ログイン・新規登録画面" />
                <img src={ help_02_02_2 } className="shadow" alt="新規登録画面" />
              </div>
              <p>
                アプリを立ち上げると、ログイン・新規登録の画面が表示されます。<br />
                前回ログインしたログイン方法のボタンに、「前回ログイン」と表示されます。<br />
                　<br />
                ◇各プロバイダでログインする場合<br />（Google・Twitter・Facebook・AppleID）<br />
                <p>
                  ログイン連携済みのプロバイダをタップするとログインできます。<br />
                  ※未連携のプロバイダでログインしようとすると、<b>新規登録となります</b>のでご注意ください。<br />
                  ※誤ってアカウントを作成してしまった場合は、使用しないアカウントにログイン後に退会してください。<br />
                  ※Facebook等のプロバイダ側で認証のタイムアウトが発生した場合は、再度プロバイダ側でログインが必要になる場合があります。<br />
                </p>
                　<br />
                ◇メールアドレスでログインする場合<br />
                <p>
                  ［メールアドレスでログイン］をタップし、『メールアドレスでログイン』画面でメールアドレスとパスワードを入力してログインしてください。<br />
                  ※パスワードを忘れた場合は、ログインボタンの下にある、「パスワードを忘れた方は<u>こちら</u>」をタップして画面に従って再設定を行なってください。<br />
                  ※メールアドレスを忘れた場合は、システム上アカウントを特定することができませんので、再度新規登録してご利用いただきますようお願い致します。<br />
                </p>
                　<br />
                ◇ログインについてのご案内<br />
                <p>
                  ※<b>ログイン方法を追加・変更する場合</b>は、<br />
                  『マイページ』→『ログイン設定』→『ログイン方法の管理』から変更してください。<br />
                  ※『ログイン方法の管理』でメールアドレスでログインする方法を解除した場合は、メールアドレスでログインの再設定はできません。<br />
                  　ログイン用のメールアドレスを変更する場合は、<br />
                  『マイページ』→『ログイン設定』→『ログイン用メールアドレスの変更』から変更してください。<br />
                </p>
              </p>
            </div>
          </div>
          
          <input type="checkbox" id="help_02_03" className="cssacc" />
          <label for="help_02_03">
            <img src={ icon_Arrow } className="icon_Arrow" />ログアウト</label>
          <div className="accshow">
            『マイページ』の画面下の［ログアウト］をクリックしてください。<br />
            <img src={ help_02_03 } className="shadow" alt="ログアウト場所" />
          </div>
          
          <input type="checkbox" id="help_02_04" className="cssacc" />
          <label for="help_02_04">
            <img src={ icon_Arrow } className="icon_Arrow" />ログインパスワードを忘れた場合</label>
          <div className="accshow">
            『メールアドレスでログイン』画面下部の［パスワードを忘れた方は<u>こちら</u>］をクリックし、『パスワード再設定』画面で登録したメールアドレスを入力し、［送信する］をタップてください。<br />
            パスワードをリセットするためのメールが届きますので、メールの内容に従ってパスワードを登録しなおしてください。<br />
            <img src={ help_02_04_1 } className="shadow" alt="『メールアドレスでログイン』画面のパスワードを忘れた場合" />
            <img src={ help_02_04_2 } className="shadow" alt="パスワード再設定画面" />
          </div>
          
          <input type="checkbox" id="help_02_05" className="cssacc" />
          <label for="help_02_05">
            <img src={ icon_Arrow } className="icon_Arrow" />メールアドレスを忘れた場合</label>
          <div className="accshow">
            メールアドレスを忘れた場合は、新たにアカウントを作成して頂くようになります。 <br />
            以前のデータはご利用いただけませんので、何卒ご了承ください。<br />
            『ログイン・新規登録』画面にてアカウントを新規登録してください。<br />
          </div>
          
          <input type="checkbox" id="help_02_06" className="cssacc" />
          <label for="help_02_06">
            <img src={ icon_Arrow } className="icon_Arrow" />メールアドレスの変更</label>
          <div className="accshow">
            <div className="flex">
              <div>
                <img src={ help_02_06 } className="shadow" alt="ログイン用メールアドレスの変更画面" />
              </div>
              <p>
              『マイページ』→『ログイン設定』→『ログイン用メールアドレスの変更』から変更してください。<br />
              その際、メールアドレスの確認メールが送信されますので受信したメールを確認して、メールを認証させてください。<br />
              メールアドレス認証後にアプリが利用可能となります。<br />
              ※確認メールが届かない場合は、迷惑メールに振り分けられていないかを確認してください。受信制限をしている場合は「@nurse-support.com」を許可してください。それでも届かない場合は登録したメールアドレスが誤っている場合がありますので、再度新規登録をしてください。<br />
              </p>
            </div>
          </div>
          
          <input type="checkbox" id="help_02_07" className="cssacc" />
          <label for="help_02_07">
            <img src={ icon_Arrow } className="icon_Arrow" />ログイン方法の管理</label>
          <div className="accshow">
            <div className="flex">
              <div>
                <img src={ help_02_07 } className="shadow" alt="ログイン方法の管理画面" />
              </div>
              <p>
              一つのアカウントで複数のログイン方法を設定することができます。<br />
              『マイページ』→『ログイン設定』→『ログイン方法の管理』からログイン方法を追加・解除できます。<br />
              <br />
              ・ログイン方法を追加する場合<br />
              　未連携のサービスをタップして、認証してください。<br />
              ・ログイン連携を解除する場合<br />
              　連携済みのサービスをタップして、連携解除してください。<br />
              　<br />
              <b>＜ご注意＞</b><br />
              メールアドレスでログインを解除すると、新たにメールアドレスでのログイン認証が設定できなくなります。<br />
              ログイン用のメールアドレスを変更する場合は『マイページ』→『ログイン設定』→『ログイン用メールアドレスの変更』から変更してください。
              </p>
            </div>
          </div>

          <input type="checkbox" id="help_02_08" className="cssacc" />
          <label for="help_02_08">
            <img src={ icon_Arrow } className="icon_Arrow" />退会</label>
          <div className="accshow">
            <p>
            『マイページ』→『退会』から退会処理ができます。<br />
            アンケートに回答したあと、［退会する］をタップすると退会処理されます。<br />
            <br />
            <b>＜ご注意＞</b><br />
            退会を行うとアカウントの情報が全て削除されます。性格診断、カレンダー、ストレスチェック、設定等のデータが閲覧できなくなります。<br />
            <br />
            退会後に再度アプリを使用する際は、アプリを終了してから再起動してください。
            </p>
            <img src={ help_02_08_1 } className="shadow" alt="マイページ（退会）" />
            <img src={ help_02_08_2 } className="shadow" alt="退会画面" />
          </div>

          <input type="checkbox" id="help_02_09" className="cssacc" />
          <label for="help_02_09">
            <img src={ icon_Arrow } className="icon_Arrow" />その他ログインについてのヘルプ</label>
          <div className="accshow">
            <p>
            <b><u>メールとパスワードでログインする方法を追加したい</u></b><br />
            現在のところ、メール・パスワードでログインする方法を追加することはできません。<br />
            メール・パスワードでログインをご利用いただくには、新規登録時に設定する必要がございます。<br />
            メール・パスワードログインをご利用いただく際は、新しく登録をやり直してご利用ください。<br />
            （現在お使いのデータに紐付け、引き継ぎをすることはできませんので、予めご了承ください。）<br />
            </p>

            <hr></hr>

            <p>
            <b><u>ログイン用のメールアドレスを間違えて設定してしまった場合</u></b><br />
            ログイン用メールアドレスの変更をされた際に、変更前のメールアドレス宛に変更確認のメールが送信されていますので内容をご確認の上、メールアドレスの変更のリセットをしてください。リセット後、変更前のメールアドレスでログインできるようになります。
            </p>

            <hr></hr>

            <p>
            <b><u>Facebookでログインしている方</u></b><br />
            Facebookのアカウントでログインできない場合は、以下の事が考えられます。<br />
            ◆Facebookのアカウントを作って間もない<br />
            Facebookのアカウントを作って間もない時は、アプリの連携ができません。アカウントの不正利用を防ぐための対策となっています。<br />
            昔からあるアカウントや、しばらくしてからアプリ連携を行ってください。<br />
            ◆Facebook側で連携をオフにしている<br />
            Facebookではアプリの連携を許可を出していないと、アプリ連携ができません。<br />
            設定でNuRseCallの連携をご確認ください。<br />
            ◆ログアウトしてから時間が経っている<br />
            ログアウトから、ログインを行うことで、アプリ連携が可能になることがあります。<br />
            ◆最終投稿してからかなり時間が経っている<br />
            投稿をすることで、アプリ連携が可能になることがあります。
            </p>
          </div>

          <h4 id="content_03">性格診断</h4>
          
          <input type="checkbox" id="help_03_01" className="cssacc" />
          <label for="help_03_01">
            <img src={ icon_Arrow } className="icon_Arrow" />性格診断について</label>
          <div className="accshow">
            NuRseCallアプリでは、まず性格タイプ診断（ナースエゴグラム）を行って頂きます。<br />
            最初に50問の3択質問に答えて、あなたの性格タイプを確認してください。<br />
            29タイプからあなたの性格にもっとも近いタイプを判定します。<br />
            タイプ診断結果はSNSでシェアできます。<br />
          </div>

          
          <h4 id="content_04">ストレス診断</h4>
          
          <input type="checkbox" id="help_04_01" className="cssacc" />
          <label for="help_04_01">
            <img src={ icon_Arrow } className="icon_Arrow" />ストレス診断について</label>
          <div className="accshow">
            月4回、簡単な質問に3択で答えるだけの定期チェックで、ストレスレベルを把握できます。<br />
            ストレス診断結果は4回目のストレスチェックが終わると更新されます。<br />
            初回登録時には、４回分のストレスチェックをしていただくと、すぐに結果がわかります。<br />
            ★ 未チェックの場合は「チェックする」ボタンがピンクになっています。<br />
            ★ チェック済みは、チェック済みと表示されます。<br />
            ★「チェックする」ボタンがグレーの場合は、まだチェックの時期になっておりませんので、チェックできる期間になりましたら通知されます。<br />
            <img src={ help_04_01 } className="shadow" alt="ホーム画面のストレス診断チェック" />
          </div>
          


          <h4 id="content_06">シフト共有カレンダー</h4>
          
          <input type="checkbox" id="help_06_01" className="cssacc" />
          <label for="help_06_01">
            <img src={ icon_Arrow } className="icon_Arrow" />シフト共有カレンダーについて</label>
          <div className="accshow">
            NuRseCallアプリを日常でも使えるアプリにするため、看護師さん用のシフト管理カレンダー機能を追加しました！<br />
            <br />
            <b>＜ 見やすいカレンダー＞</b><br />
            ◆ シフトも、プライベートの予定もこのカレンダーひとつで管理できます。<br />
            ◆ １つの画面でシフト一覧や、その日の予定を見ることができます。<br />
            ◆ シフトは帯表示、予定はアイコンで表示されます。アイコンは随時追加されます。<br />
            ◆ カレンダーは月・週・リストの３種類で、スケジュールを確認しやすくしています。<br />
            <br />
            <b>＜ 簡単便利なシフト入力 ＞</b><br />
            ◆ シフトをスタンプ感覚で連続で入力でき、短時間でシフトの入力ができます。<br />
            ◆ 複雑なシフトにも対応！1日に最大3件までシフトを入力できます。<br />
            ◆ 登録したシフト毎に、メモや勤務メンバーを登録することができます。<br />
            ◆ シフトの表示内容やカラーは編集ができるので、よく利用する予定やタスクを登録したりなど、色々な使い方ができます。<br />
            <br />
            <b>＜ 仲間とシフトを共有 ＞</b><br />
            ◆ 職場はもちろん、同期の仲間や友人、家族とシフトを共有することができます。<br />
            ◆ 共有するグループは作成・招待・参加ができ、管理者機能で安全に運用できます。<br />
            ◆ 共有しているシフトはリアルタイムで更新されます。<br />
            ◆ グループの参加者はアイコンや名前を自由に設定できます。ニックネームにしたり、お気に入りの写真をアイコンにしてもOK!<br />
          </div>

          <input type="checkbox" id="help_06_02" className="cssacc" />
          <label for="help_06_02">
            <img src={ icon_Arrow } className="icon_Arrow" />各アイコン・画面の説明</label>
          <div className="accshow">
            <div className="flex">
              <img src={ help_06_02_1 } className="shadow" alt="月カレンダー" />
              <p>
              <b>◆ 月カレンダー</b><br />
                <br />
                月カレンダーは、指定した月の全体的な予定を素早く確認できます。<br />
                <br />
                ①カレンダー表示切り替え<br />
                ②前月を表示<br />
                ③翌月を表示<br />
                ④シフト共有を表示<br />
                ⑤シフト・予定アイコンを表示<br />
                　見たい日付をタップするとその日のスケジュールが画面下部に表示される<br />
                ⑥シフト入力画面を表示<br />
                ⑦予定入力画面を表示<br />
                ⑧選択された日のシフトを表示<br />
                ⑨選択された日の予定を表示<br />
              </p>
            </div>
            <hr></hr>
            <div className="flex">
              <img src={ help_06_02_2 } className="shadow" alt="週カレンダー" />
              <p>
              <b>◆ 週カレンダー</b><br />
                <br />
                週カレンダーは、週ごとの予定を表示します。<br />
                月カレンダーよりも枠が広い為、予定が多い日の詳細も確認しやすくなります。<br />
                <br />
                ①カレンダー表示切り替え<br />
                ②前週を表示<br />
                ③翌週を表示<br />
                ④シフト共有を表示<br />
                ⑤シフト・予定アイコンを表示<br />
                　見たい日付をタップするとその日のスケジュールが画面下部に表示される<br />
                ⑥シフト入力画面を表示<br />
                ⑦予定入力画面を表示<br />
                ⑧選択された日のシフトを表示<br />
                ⑨選択された日の予定を表示<br />
                ※リストの表示順は、上から⑧シフト、⑨予定（重要予定→終日→開始時間）の順番で表示
              </p>
            </div>
            <hr></hr>
            <div className="flex">
              <img src={ help_06_02_3 } className="shadow" alt="リストカレンダー" />
              <p>
              <b>◆ リストカレンダー</b><br />
                <br />
                リストカレンダーは、指定した月のスケジュールを日付順に全て表示します。<br />
                <br />
                ①カレンダー表示切り替え<br />
                ②前月を表示<br />
                ③翌月を表示<br />
                ④シフト共有を表示<br />
                ⑤予定入力画面を表示<br />
                ⑥各日のシフト・予定全てを表示<br />
                ※リストの表示順は、上から⑧シフト、⑨予定（重要予定→終日→開始時間）の順番で表示<br />
              </p>
            </div>
            <hr></hr>
            <div className="flex">
              <img src={ help_06_02_4 } className="shadow" alt="シフト共有" />
              <p>
              <b>◆ シフト共有画面</b><br />
                <br />
                シフト共有は、共有するグループを作成するとこで表示されます。<br />
                職場はもちろん、同期や友人、家族とシフトをリアルタイムで共有することが可能です。<br />
                また、休日に予定を合わせることを想定し、シフトで休日の設定をすることで休日の表示が統一され、確認しやすくしています。<br />
                <br />
                ①月カレンダーを表示<br />
                ②前月を表示<br />
                ③翌月を表示<br />
                ④表示しているグループにメンバーを招待する<br />
                ⑤表示しているグループの設定を表示<br />
                ⑥表示するグループの切り替え<br />
                ⑦シフト名・シフト時間の表示を切り替え<br />
              </p>
            </div>
          </div>

          <input type="checkbox" id="help_06_03" className="cssacc" />
          <label for="help_06_03">
            <img src={ icon_Arrow } className="icon_Arrow" />シフトの入力・変更・削除方法</label>
          <div className="accshow">
            <div className="flex">
              <img src={ help_06_03_1 } className="shadow" alt="連続シフト入力" />
              <p>
                月カレンダー、週カレンダーで「シフト入力」をタップすると画面下部にシフト入力画面が表示されます<br />
                <br />
                ・【×ボタン】をタップするとシフト入力画面を終了します。<br />
                <br />
                ・シフトのアイコンをタップすると、上部のカレンダーで選択されている日付（ピンク枠のある日）に入力されます。<br />
                <br />
                ・【シフト連続入力】を’オン’にするとシフトを1件入力したら翌日にフォーカスが自動で移動するので、シフトをタップしていくだけで連続で入力することができます。<br />
                ・シフトの変更も、【シフト連続入力】が’オン’の場合はタップしたシフトに上書きされ、翌日にフォーカスが移動するので連続で変更が可能です。1日だけ変更したい場合はご注意ください。<br />
                ・削除に関しても、【シフト連続入力】が’オン’の場合はシフトを削除すると翌日にフォーカスが移動するので連続で削除ができます。<br />
                ※1日に複数件シフトがある場合は、上から順に削除されます。<br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_03_2 } className="shadow" alt="シフト入力" />
              <p>
                ・【シフト連続入力】を’オフ’にすると、シフトを入力しても翌日にフォーカスは移動しません。1日に3件までシフトを入力できます。<br />
                <br />
                ・削除に関しても、【シフト連続入力】を’オフ’の場合はシフトを削除してもフォーカスは移動しません。<br />
                ※1日に複数件シフトがある場合は、上から順に削除されます。<br />
                <br />
                ・シフトを編集する場合は、【シフト連続入力】を’オフ’のときは上書きされませんので、編集する日のシフトを削除してから入力しなおしてください。<br />
                　<br />
                【シフト編集】をタップすると、［設定］＞［シフトパターン編集］の画面に遷移します。<br />
                ［シフトパターン編集］画面では、シフト入力画面に表示するシフトの並べ替えや、シフト名、時間、色、通知の設定が可能です。
              </p>
            </div>
            <hr />
            <div className="flex">
              <img src={ help_06_03_3 } className="shadow" alt="シフト編集" />
              <p>
                その日ごとの選択したシフトの内容（シフトタイトル・時間・通知・勤務メンバー・メモ）の編集ができます。<br />
                ※シフトパターン（日勤・夜勤等）自体の変更は、設定から変更できます。<br />
                　<br />
                画面下部のリストから、詳細設定をしたいシフトをタップすると、編集用のポップアップが表示されます。<br />
                シフトの削除もこちらから行えます。
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_03_4 } className="shadow" alt="シフト編集(シフトタブ)" />
              <p>
                【×ボタン】<br />
                シフト編集用のポップアップを閉じます。<br />
                【日付】<br />
                表示されている日付のシフトを編集します。<br />
                【保存ボタン】<br />
                編集した内容が保存されます。<br />
                　<br />
                【シフト】タブ<br />
                ・シフトの詳細（タイトル）を変更できます。<br />
                ここにタイトルを入力すると、カレンダーのシフトリスト部分に表示されます。勤務場所や業務内容などうぃ表示したい場合に役立ちます。<br />
                ・「時間/終日」切り替えボタンは、時間を入力する場合は『時間』をオン、終日予定の場合は『終日』をオンにしてください。<br />
                （終日にしている場合は時間の入力はできません）<br />
                ・時間の部分には予定の開始時間、終了時間を入力してください。<br />
                  間違って入力した場合は時間枠をタップすると削除されますので、入力しなおしてください。<br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_03_5 } className="shadow" alt="シフト編集(通知タブ)" />
              <p>
                　<br />
                【通知】タブ<br />
                その日の選択したシフト（1件）の通知を設定できます。<br />
                通知は複数設定できます。自分で通知時間を設定することもできます。<br />
                通知はプッシュ通知されます。<br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_03_6 } className="shadow" alt="シフト編集(勤務メンバータブ)" />
              <p>
                　<br />
                【勤務メンバー】タブ<br />
                その日の選択したシフト（1件）の勤務メンバーを登録できます。<br />
                登録した勤務メンバーは、週カレンダー・リストカレンダー・シフト詳細（ポップアップ表示）にて確認できます。<br />
                勤務メンバーの名前や並び順は、『設定』→『勤務メンバー設定』で変更できます。<br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_03_7 } className="shadow" alt="シフト編集(メモタブ)" />
              <p>
              　<br />
                【メモ】タブ<br />
                シフトの詳細（場所やURL、連絡先など）や、メモを入力して自由にご利用いただけます。
              </p>
            </div>
          </div>

          <input type="checkbox" id="help_06_04" className="cssacc" />
          <label for="help_06_04">
            <img src={ icon_Arrow } className="icon_Arrow" />予定の入力・編集・削除方法</label>
          <div className="accshow">
            <div className="flex">
              <img src={ help_06_04_1 } className="shadow" alt="予定入力" />
              <p>
                【予定の入力】<br />
                各カレンダーの「予定入力」をタップすると、予定入力用のポップアップが表示されますので、必要な項目を入力して保存してください。<br />
                <br />
                【予定の変更】<br />
                各カレンダーの画面下部に表示されている予定（リスト）をタップすると、予定編集用のポップアップが表示されますので、編集して保存してください。<br />
                <br />
                【予定の削除】<br />
                各カレンダーの画面下部に表示されている予定（リスト）をタップすると、予定編集用のポップアップが表示されますので、「予定削除」をタップして削除してください<br />
                <br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_04_2 } className="shadow" alt="予定入力（予定タブ）" />
              <p>
                【×ボタン】<br />
                予定入力用のポップアップを閉じます。<br />
                【日付】<br />
                表示されている日付の予定を入力します。<br />
                【保存ボタン】<br />
                入力した内容が保存されます。<br />
                【予定】タブ<br />
                ・予定のアイコンを変更するには、下のアイコンをタップしてください。<br />
                ・予定のタイトルを入力することができます。※文字数が多い場合は省略表示されます<br />
                ・「☆重要」をオンにすると、カレンダーの表示の上位に表示されるようになります。<br />
                ・アイコンは、カテゴリ分けされており、カテゴリをタップして切り替えます。
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_04_3 } className="shadow" alt="予定入力（時間タブ）" />
              <p>
                【時間】タブ<br />
                予定の時間を設定できます。<br />
                ・「時間/終日」切り替えボタンは、時間を入力する場合は『時間』をオン、終日予定の場合は『終日』をオンにしてください。<br />
                （終日にしている場合は時間の入力はできません）<br />
                ・時間の部分には予定の開始時間、終了時間を入力してください。<br />
                  間違って入力した場合は時間枠をタップすると削除されますので、入力しなおしてください。
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_04_4 } className="shadow" alt="予定入力（繰り返しタブ）" />
              <p>
                【繰り返し】タブ<br />
                予定の繰り返し設定ができます。<br />
                既に繰り返し予定で保存した予定の、繰り返し設定は変更できません。<br />
                繰り返し設定の変更が必要な場合は一度繰り返し予定を削除してから、再度予定を登録し直してください。<br />
                予め繰り返し数が決められている項目は、引き続き必要な場合は新規で繰り返しの予定を追加してください。<br />
                　<br />
                ※繰り返し予定が設定できない場合<br />
                1日に登録できる予定の最大件数は30件までとなります。繰り返し予定の日付の中にすでに予定が30件があった場合はその日付の作成処理がスキップされるようになっています。
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_04_5 } className="shadow" alt="予定入力（通知タブ）" />
              <p>
                【通知】タブ<br />
                予定の通知を設定できます。<br />
                通知は複数設定できます。自分で通知時間を設定することもできます。<br />
                通知はプッシュ通知されます。
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_04_6 } className="shadow" alt="予定入力（メモタブ）" />
              <p>
                【メモ】タブ<br />
                予定の詳細（場所やURL、連絡先など）や、メモを入力して自由にご利用いただけます。
              </p>
            </div>
          </div>

          <input type="checkbox" id="help_06_05" className="cssacc" />
          <label for="help_06_05">
            <img src={ icon_Arrow } className="icon_Arrow" />シフト共有のしかた</label>
          <div className="accshow">
            <div className="flex">
              <img src={ help_06_05_1 } className="shadow" alt="シフト共有" />
              <p>
              <b>◆ シフト共有グループの作成方法</b><br />
                <br />
                <u>シフトグループに参加していない場合</u><br />
                シフト共有画面を表示すると「シフトグループに参加していない為表示できません。<br />
                シフトグループを作成しますか？」と確認されるので、［作成］をタップしてください。<br />
                『シフトグループ設定』画面が表示されますので、<br />
                ［＋新規グループを作成］ボタンをタップしてください。<br />
                『新規グループ作成』画面が表示されます。<br />
                　<br />

                <u>すでに他のシフトグループに参加している場合</u><br />
                『設定』→『シフトグループ設定』画面から<br />
                ［＋新規グループを作成］ボタンをタップしてください。<br />
                『新規グループ作成』画面が表示されます。<br />
              </p>
            </div>
            <div className="flex">
              <img src={ help_06_05_2 } className="shadow" alt="シフト共有" />
              <p>
                『新規グループ作成』画面にて<br />
                ・グループ名<br />
                ・メモ（グループの説明など）<br />
                ・あなたの表示名<br />
                ・アイコン<br />
                を入力、設定して、画面右上の［保存］ボタンをタップして保存してください。<br />
                <br />
                アイコンは、自分の好きな画像をアイコンに変更できます。アイコンの横の［変更］をタップして変更できます。
              </p>
            </div>
            <hr></hr>
            <div className="flex">
              <img src={ help_06_05_3 } className="shadow" alt="シフト共有画面" />
              <p>
              <b>◆ シフト共有の招待</b><br />
                <br />
                １．①で招待したいグループの共有画面を表示します。<br />
                ２．②のアイコンをタップすると、「このグループにメンバーを招待しますか？」と表示されるので［招待する］をタップします。<br />
                ※『設定』→『シフトグループ設定』→［招待するグループ］→『グループ詳細設定』画面で［グループにメンバーを招待］でも招待ができます。<br />
                ３．シフト共有への招待用テキストが作成されますので、任意の共有方法で共有してください。<br />
                ４．招待した相手がグループに参加すると、送信元のユーザーとグループ管理者に参加承認の確認が通知表示されます。<br />
                ５．承認をするには、『設定』→『シフトグループ設定』画面で、承認待ちがあるグループをタップします。<br />
                ６．『グループ詳細設定』→『招待メンバーを承認』画面で承認してください。<br />
                ※招待を間違えて拒否した場合は、再度招待をし直してください。<br />
              </p>
            </div>
            <img src={ help_06_05_4 } className="shadow" alt="シフトグループ設定画面" />
            <img src={ help_06_05_5 } className="shadow" alt="招待メンバー承認画面" />
            <hr></hr>
            <div className="flex">
              <p>
              <b>◆ シフト共有についてのその他ヘルプ</b><br />
              　<br />
              <b><u>シフトグループに入るには</u></b><br />
              グループのメンバーに招待用URLを送信してもらってください。<br />
              　<br />
              <b><u>招待のURLをタップしてもエラーになる場合</u></b><br />
              招待の有効期限が切れているか、グループが削除された可能性があります。再度招待を送り直してもらってください。<br />
              　<br />
              <b><u>アイコン用の画像をカメラで撮影できない場合</u></b><br />
              iPhoneの設定から『NuRseCall』をタップし、NuRseCallの管理画面でカメラをオンにしてください。<br />
              　<br />
              </p>
            </div>
          </div>


          <h4 id="content_05">マイページ</h4>
          
          <input type="checkbox" id="help_05_01" className="cssacc" />
          <label for="help_05_01">
            <img src={ icon_Arrow } className="icon_Arrow" />お知らせ</label>
          <div className="accshow">
            NuRseCallアプリに関するお知らせ（メンテナンスやアップデート情報等）や、キャンペーン・特集などが表示されます。<br />
          </div>

          <input type="checkbox" id="help_05_02" className="cssacc" />
          <label for="help_05_02">
            <img src={ icon_Arrow } className="icon_Arrow" />プロフィールの確認・編集</label>
          <div className="accshow">
            マイページにてプロフィールを確認できます。<br />
            プロフィールの編集は『マイページ』画面の下部の『プロフィール編集』ボタンから編集できます。<br />
            <div className="flex">
              <img src={ help_05_02_1 } className="shadow" alt="プロフィール画面" />
              <img src={ help_05_02_2 } className="shadow" alt="プロフィール画面" />
            </div>
          </div>

          <input type="checkbox" id="help_05_03" className="cssacc" />
          <label for="help_05_03">
            <img src={ icon_Arrow } className="icon_Arrow" />お問い合せ</label>
          <div className="accshow">
            アプリに関するお問い合せを受け付けております。<br />
            お問い合せの他に、改善のご要望などございましたら是非ご連絡ください。<br />
            『マイページ』画面の下部の『お問い合わせ』ボタンからお問い合わせください。<br />
            <div className="flex">
              <img src={ help_05_03_1 } className="shadow" alt="マイページ画面" />
              <img src={ help_05_03_2 } className="shadow" alt="お問い合わせ画面" />
            </div>
          </div>



          <h4 id="content_07">設定</h4>

          <input type="checkbox" id="help_07_01" className="cssacc" />
          <label for="help_07_01">
            <img src={ icon_Arrow } className="icon_Arrow" />プッシュ通知設定</label>
          <div className="accshow">
            アプリ全体のプッシュ通知を受けるかどうかを設定します。<br />
            <br />
            プッシュ通知の内容は、ストレスチェックのタイミング、お知らせ、スケジュール、シフト共有グループの通知が主な通知となります。<br />
            通知をオフにする場合は、「プッシュ通知設定」をタップするとOSの設定画面が開きますので、「通知」からNuRseCallアプリの通知をオフにしてください。<br />
            通知を再開する場合も、上記と同様の方法でにOSの通知設定で「通知」をオンにしてください。<br />
          </div>

          <input type="checkbox" id="help_07_02" className="cssacc" />
          <label for="help_07_02">
            <img src={ icon_Arrow } className="icon_Arrow" />パスコードロック</label>
          <div className="accshow">
            アプリをパスコードでロックすることができます。<br />
            <br />
            ４桁の数字を入力し、再度確認で同じ数字４桁を入力して設定完了です。<br />
            パスコードを変更する場合は、パスコードを一旦オフにすると初期化されますので、別のパスコードで再度設定してください。<br />
            パスコードを忘れてしまった場合は、アプリを一度削除（アンインストール）して、再インストールをしてください。※データは削除されませんので、ご安心ください。<br />
          </div>



          <h4 id="content_10">その他</h4>
          
          <input type="checkbox" id="help_10_01" className="cssacc" />
          <label for="help_10_01">
            <img src={ icon_Arrow } className="icon_Arrow" />運営会社</label>
          <div className="accshow">
            株式会社スタートアッププラス<br />
            E-mail：info@nurse-support.com<br />
            〒106-0052　東京都港区赤坂6-4-19<br />
            赤坂T.S.C.ビル5階<br />
            <a href="https://www.startup-plus.com/about-us/" target="_blank">ホームページ</a><br />
            <a href="https://www.startup-plus.com/privacy-policy/" target="_blank">プライバシーポリシー</a><br />     
          </div>
          
          <input type="checkbox" id="help_10_02" className="cssacc" />
          <label for="help_10_02">
            <img src={ icon_Arrow } className="icon_Arrow" />イラスト・キャラクターについて</label>
          <div className="accshow">
            ■イラストレーター情報<br />
            デザインイラストはまべろこ/ROCOCREATE<br />
            <a href="http://rococreate.com/" target="_blank">http://rococreate.com/</a><br />
            <br />
            ■アプリ・サイト内の女性イラスト（キャラクター）の著作権について<br />
            「NuRseCall」アプリ、当ホームページ上のキャラクターは全て著作物となっております。
            無断で複写・転用・使用する事は、権利の侵害にあたりますので絶対におやめください。<br />
          </div>
          
          <input type="checkbox" id="help_10_03" className="cssacc" />
          <label for="help_10_03">
            <img src={ icon_Arrow } className="icon_Arrow" />ヘルプにて解決できない場合はお問い合せください</label>
          <div className="accshow">
            上記ヘルプに記載のない疑問やお問い合せは<Link to="/contact">こちらのお問い合せフォーム</Link>にてお問い合せください。<br />        
          </div>
          
        </div>
      </main>
    </div>
  );
};
export default HelpContents